import { mapGetters } from 'vuex'
import * as partials from 'src/partials'

export default {
  components: {
    ...partials
  },
  computed: {
    ...mapGetters({
      user: 'passport/user',
      verificator: 'passport/defaultVerificator'
    })
  }
}
